import React, { Component } from "react";
import {
	Container,
	Card,
	CardHeader,
	Button,
	CardBody,
	Row,
	Table,
	Col,
} from "reactstrap";

import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "../reports.scss";

// import "../app-invoice.css";
import { getSRDocReport } from "../../../store/Reports/actions";
import DefaultImg from "../../../assets/images/product/Default_img.jpg";
import SLE_logo from "../../../assets/images/SriLalitha_Logo.png";

class SRReportDocument extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {
		this.props.getSRDocReport(this.props.match.params.id);
	}
	// getPDFReport() {
	//   //	297 x 210 mm
	//   const codewidth = document.getElementById("toPdf").style.width;
	//   document.getElementById("toPdf").style.width = "297mm";
	//   const doc = new jsPDF("l", "mm", [297, 210]);
	//   doc.setDisplayMode(1);
	//   doc.html(document.getElementById("toPdf"), {
	//     callback: function (doc) {
	//       doc.save();
	//       document.getElementById("toPdf").style.width = codewidth;
	//     },
	//     x: 0,
	//     y: 0,
	//     html2canvas: { scale: 0.25 },
	//   });
	// }

	getPDFReport = async () => {
		const element = document.getElementById("toPdf");
		if (!element) return;

		const originalWidth = element.style.width;
		element.style.width = "297mm";
		element.style.maxWidth = "290mm";

		const pdf = new jsPDF("p", "mm", "a4");
		const pageWidth = pdf.internal.pageSize.getWidth();
		const pageHeight = pdf.internal.pageSize.getHeight();

		// Use a higher scale for better text clarity
		const canvas = await html2canvas(element, {
			scale: 3,
			useCORS: true,
			scrollX: 0,
			scrollY: 0,
			windowWidth: element.scrollWidth,
			windowHeight: element.scrollHeight,
		});

		const imgData = canvas.toDataURL("image/png");
		const imgWidth = pageWidth;
		const imgHeight = (canvas.height * imgWidth) / canvas.width;

		let heightLeft = imgHeight;
		let position = 0;

		pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
		heightLeft -= pageHeight;

		while (heightLeft > 0) {
			position -= pageHeight;
			pdf.addPage();
			pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
			heightLeft -= pageHeight;
		}

		pdf.save("Service_Request_Report.pdf");

		// Revert back to original
		element.style.width = originalWidth;
	};
	reportBody() {
		return (
			<Row className="p-1 report-preview">
				<Col md={12} className="p-1">
					<Card className="p-1 report-preview-card">
						<CardBody className="report-padding pb-0">
							<div className="report-body flex-sm-row flex-column  mt-0">
								<div className=" ">
									<h5 className="card-title-16 pt-2 ">
										SRI LALITHA ENTERPRISES INDUSTRIES PVT.
										LTD
									</h5>
									<p className="card-title-14 pt-2 mb-0">
										Valuthimmapuram Road, PEDDAPURAM -
										533437, E.G. Dist. - AP
									</p>
									<p className="card-title-14 pt-2 mb-0">
										Phone No.0884-2326661, 62, Mobile
										No.9494127893,
									</p>
									<p className="card-title-14 pt-2 mb-0">
										Email: purchase@sleipl.com,
										lalitharice@gmail.com
									</p>
									<p className="card-title-14 pt-2">
										GSTIN : 37AAKCS3233N1ZX
									</p>
								</div>
								<div className="pt-2">
									<span className="p-4">
										<img
											className="img-fluid p-0"
											src={SLE_logo}
											alt="Logo"
											width="100"
											height="120"
										/>
									</span>
									<h4 className="report-title mb-0">
										Service Request{" "}
									</h4>
									<h5 className="report-title">
										<span className="report-number">
											#{this.props.SR_Doc_report.code}
										</span>
									</h5>
								</div>
							</div>
							<hr className="hr-black-color " />

							<div className="report-body flex-sm-row flex-column mt-0">
								<div>
									<div className="report-wrapper">
										<p className="report-wrapper-title">
											Create By:
										</p>
										<p className="report-wrapper-det">
											{
												this.props.SR_Doc_report
													.createdby?.fullname
											}{" "}
											(
											{
												this.props.SR_Doc_report
													.createdby?.username
											}
											)
										</p>
									</div>
									<div className="report-wrapper">
										<p className="report-wrapper-title">
											Location:
										</p>
										<p className="report-wrapper-det">
											{
												this.props.SR_Doc_report
													.location?.name
											}
										</p>
									</div>
									<div className="report-wrapper">
										<p className="report-wrapper-title">
											Sub Location:
										</p>
										<p className="report-wrapper-det">
											{
												this.props.SR_Doc_report
													.sublocation?.name
											}
										</p>
									</div>

									<div className="report-wrapper">
										<p className="report-wrapper-title">
											User Department:
										</p>
										<p className="report-wrapper-det">
											{
												this.props.SR_Doc_report
													.userdepartment?.name
											}
										</p>
									</div>
								</div>
								<div>
									<div className="report-wrapper">
										<p className="report-wrapper-title">
											Status:
										</p>
										<p className="report-wrapper-det">
											{
												this.props.SR_Doc_report
													.srstatus_name
											}
										</p>
									</div>
									<div className="report-wrapper">
										<p className="report-wrapper-title">
											Submited On:
										</p>
										<p className="report-wrapper-det">
											{moment(
												this.props.SR_Doc_report
													.createdon
											).format("DD-MM-YYYY")}
										</p>
									</div>
									<div className="report-wrapper">
										<p className="report-wrapper-title">
											Requested On:
										</p>
										<p className="report-wrapper-det">
											{moment(
												this.props.SR_Doc_report.date
											).format("DD-MM-YYYY")}
										</p>
									</div>
									<div className="report-wrapper">
										<p className="report-wrapper-title">
											HOD(U) Approved by:
										</p>
										<p className="report-wrapper-det">
											{
												this.props.SR_Doc_report
													.userDeptApprovedby &&
													this.props.SR_Doc_report
														.userDeptApprovedby[
														this.props.SR_Doc_report
															.userDeptApprovedby
															.length - 1
													]?.approvedby.fullname
												// this.props.SR_Doc_report.mr_approvals.length - 1
											}
										</p>
									</div>
								</div>
							</div>
							<hr className="hr-black-color " />
							<div className="m-0">
								{/* <TableScrollbar height="400px"> */}
								<Table
									// striped
									bordered
									// hover
									className="mb-0 p-0 table-centered table-color-black">
									<thead className="bg-light text-center">
										<tr>
											<th style={{ width: "3%" }}>
												S.NO
											</th>
											<th style={{ width: "15%" }}>
												Item Image
											</th>
											<th style={{ width: "30%" }}>
												Item Name
											</th>
											<th style={{ width: "8%" }}>
												Quantity
											</th>
											<th style={{ width: "10%" }}>
												Approved Qty
											</th>
											<th style={{ width: "8%" }}>
												Department
											</th>
											<th style={{ width: "11%" }}>
												Requested On
											</th>
											<th style={{ width: "8%" }}>
												Approved by
											</th>
											<th style={{ width: "7%" }}>
												Status
											</th>
										</tr>
									</thead>
									<tbody>
										{this.props.SR_Doc_report?.sritems?.map(
											(item, key) => (
												<tr key={key}>
													<td className="text-center">
														{key + 1}
													</td>
													<td className="nowrap text-center">
														<div className="product-detail text-center">
															<img
																src={
																	item
																		?.product
																		.image ==
																	null
																		? DefaultImg
																		: item
																				?.product
																				.image
																}
																alt="product-img"
																title="product-img"
																className="product-img  img-fluid mx-auto tab-img rounded"
																style={{
																	height: "100px",
																	width: "150px",
																}}
															/>
														</div>
													</td>
													<td>
														<h5 className="font-size-14 ">
															{
																item?.product
																	?.name
															}
														</h5>
														<p className="mb-0">
															Make :{" "}
															<span className="font-weight-medium">
																{item.make}
															</span>
														</p>
														<p className="mb-0">
															Description :{" "}
															<span className="font-weight-medium">
																{
																	item.description
																}
															</span>
														</p>
														{(item.srstatus === 4 ||
															item.srstatus ===
																6) && (
															<p className="mb-0">
																<b className="text-danger ">
																	Reject
																	Remark :
																</b>{" "}
																<span>
																	{
																		item
																			.sri_approvals[
																			item
																				.sri_approvals
																				.length -
																				1
																		]
																			.description
																	}
																</span>
															</p>
														)}
													</td>
													<td className="text-center">
														{item.sri_approvals
															?.length === 0
															? item.qty +
															  " " +
															  item.unit?.name
															: item
																	.sri_approvals[0]
																	.f_qty +
															  " " +
															  item
																	.sri_approvals[0]
																	.f_unit
																	.name}
													</td>

													<td className="text-center">
														{item.qty}{" "}
														{item.unit?.name}
													</td>
													<td className="text-center">
														{item.department.name}
													</td>
													<td className="nowrap text-center">
														{item.date}
													</td>

													<td className=" text-center">
														{
															item.sri_approvals[
																item
																	.sri_approvals
																	.length - 1
															]?.approvedby
																.fullname
														}
													</td>
													<td className=" text-center">
														{
															item.sri_approvals[
																item
																	.sri_approvals
																	.length - 1
															]?.srstatus_name
														}
													</td>
												</tr>
											)
										)}
									</tbody>
								</Table>
								{/* </TableScrollbar> */}
							</div>
						</CardBody>
					</Card>
				</Col>
			</Row>
		);
	}
	render() {
		return (
			<React.Fragment>
				<div className="page-content">
					<Container fluid>
						<Row>
							<Col md={12}>
								<Card>
									<CardHeader className="bg-transparent border-bottom no-print ">
										<Link
											to="#"
											onClick={() =>
												this.props.history.goBack()
											}
											className="action-icon text-primary mr-2">
											<i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
										</Link>
										<div className="float-right">
											<div className="d-inline-block ">
												<Button
													type="button"
													outline
													color="secondary"
													className=" mr-2"
													onClick={() =>
														this.getPDFReport()
													}>
													<i className="ri-file-excel-2-line"></i>
													<span className="d-none d-inline-block ml-1">
														PDF
													</span>
												</Button>

												<Button
													type="button"
													outline
													color="secondary"
													className=" mr-2"
													onClick={() =>
														window.print()
													}>
													<i className="mdi  mdi-printer"></i>
													<span className="d-none d-inline-block ml-1">
														Print
													</span>
												</Button>
											</div>
										</div>
									</CardHeader>
									<CardBody
										className="pt-1 mr-auto mx-auto"
										id="toPdf">
										{this.reportBody()}
									</CardBody>
								</Card>
							</Col>
						</Row>
					</Container>
				</div>
			</React.Fragment>
		);
	}
}

const mapStatetoProps = (state) => {
	const { SR_Doc_report } = state.reports;
	return {
		SR_Doc_report,
	};
};

export default connect(mapStatetoProps, {
	getSRDocReport,
})(SRReportDocument);
